import {createStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import {IS_AVAILABLE_LOCAL_STORE} from '../../config'
import {CheckoutRootState as RootState} from '../../interfaces'
import {
    authMiddleware,
    orderInterruptedMiddleware,
    sessionSyncMiddleware,
    uiEventActions,
    uiEventLoggerMiddleware,
    sentryTransactionMiddleware,
    errorLoggerMiddleware,
    loggerMiddleware,
    maintenanceHandlerMiddleware,
} from '../../store/checkout/middlewares'

import createRootReducer from './reducer'
import SmartstoreCheckoutSentryEnhancer from './sentryEnhancer'

export const createCheckoutStore = () => {
    return createStore<RootState>({
        rootReducerCreator: createRootReducer,
        middlewares: [
            authMiddleware,
            maintenanceHandlerMiddleware,
            loggerMiddleware,
            orderInterruptedMiddleware,
            sessionSyncMiddleware,
            uiEventLoggerMiddleware,
            sentryTransactionMiddleware,
            browserEventEmitter,
            errorLoggerMiddleware,
        ],
        defaultMiddlewareOptions: {
            serializableCheck: {
                ignoredActions: [...uiEventActions],
            },
        },
        sentryEnhancerOptions: SmartstoreCheckoutSentryEnhancer,
    })
}

/** 스마트 스토어 주문서 store */
const store = createCheckoutStore()

if (IS_AVAILABLE_LOCAL_STORE) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any).store = store
}

export default store
